<template>
  <div>
    <div
        id="aria-live-region"
        aria-live="polite"
        aria-atomic="true"
        style="position: absolute; top: -9999px; left: -9999px; height: 1px; width: 1px; overflow: hidden;"
      >
        {{ refreshAriaEventMessage ? t(refreshAriaEventMessage) : '' }}
    </div>
    <div class="refresh-button" >
      <v-btn 
      :aria-label="buttonAriaLabel"
      :disabled="disabledButton" 
      variant="plain" 
      @click="handleRefreshButtonClick" 
      >
        <img
        class="refresh-icon"
        src="@/assets/refreshBtn.svg"
        :alt="t('refreshButton.refreshIconAlt')"
        :class="{
          'disabled-image': disabledButton,
          'refresh-icon-spinning': loadingData,
        }"
        />
        <v-progress-circular  
        class="progress-circle"      
        :model-value="percentProgress"
        size="41"
        width="4"
        color="red"/>
      </v-btn>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import dayjs from 'dayjs';
import { useI18n } from 'vue-i18n';

export default {
  setup() {
    const { t } = useI18n();
    return { t };
  },
  data() {
    return {
      progress: 0,
      maxRefreshes: 0,
      remainingRefreshes: 0,
      lastRefreshed: new Date().toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      }),

      disabledButton: true,

      disableButtonTimer: null,
      intialDisabledButtonInterval: 0,
      timeUntilButtonEnabled: 0,

      autoRefreshTimer: null,
      intialAutoRefreshInterval: 0,
      timeUntilAutoRefresh: 0,

    };
  },
  mounted() {
    this.maxRefreshes = parseInt(process.env.VUE_APP_REFRESH_TIMER_MAX_REFRESHES_VALUE, 10);
    this.remainingRefreshes = this.maxRefreshes;

    this.intialDisabledButtonInterval = parseInt(process.env.VUE_APP_REFRESH_TIMER_DISABLE_VALUE, 10);
    this.timeUntilButtonEnabled = this.intialDisabledButtonInterval;

    this.intialAutoRefreshInterval = parseInt(process.env.VUE_APP_REFRESH_TIMER_VALUE, 10);
    this.timeUntilAutoRefresh = this.intialAutoRefreshInterval;


    this.startDisabledButtonTimer();
    this.startAutoRefreshTimer();
  },
  unmounted() {
    clearInterval(this.disableButtonTimer);
    clearInterval(this.autoRefreshTimer);
  },

  methods: {
    ...mapActions(["fetchData", "updateLastRefreshedDateTime"]),
    handleRefresh() {
      this.remainingRefreshes--;
      this.timeUntilAutoRefresh = this.intialAutoRefreshInterval;
      this.fetchData(this.$route.params.id);
      this.updateLastRefreshedDateTime(dayjs());
      this.startDisabledButtonTimer();

      if (this.remainingRefreshes < 1) {
         this.disabledButton = true;
        clearInterval(this.autoRefreshTimer);

        return;
      }
      this.disabledButton = true;

    },
    handleRefreshButtonClick() {
      this.handleRefresh();
    },
    startDisabledButtonTimer() {
      this.timeUntilButtonEnabled = this.intialDisabledButtonInterval;
      this.disableButtonTimer = setInterval(() => {
        this.timeUntilButtonEnabled--;
        if (this.timeUntilButtonEnabled <= 0) {
          this.disabledButton = false;
          clearInterval(this.disableButtonTimer);
        }
      }, 1000);
    },
    startAutoRefreshTimer() {
      this.autoRefreshTimer = setInterval(() => {
        this.timeUntilAutoRefresh--;
        if (this.timeUntilAutoRefresh <= 0) {
          this.handleRefresh();
        }
      }, 1000);
    },
  },
  computed: {
    ...mapState(["refreshAriaEventMessage", "lastRefreshedDateTime", "loadingData"]),
    buttonAriaLabel() {
      if (this.timeUntilButtonEnabled != 0 && (this.timeUntilButtonEnabled != this.intialDisabledButtonInterval)) {
        return this.t('refreshButton.refreshButtonDisabled', { seconds: this.timeUntilButtonEnabled });
      }
      return this.t('refreshButton.refreshButton');
    },
    textAriaLabel() { return `${this.t('refreshLabel.lastRefreshed')} ${ this.lastRefreshed }` },

    percentProgress() {
      return (
        ((this.intialAutoRefreshInterval - this.timeUntilAutoRefresh) /
          this.intialAutoRefreshInterval) *
        100
      );
    },
  },
};
</script>

<style>
.refresh-label {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  color: rgb(var(--v-theme-surface-variant)) !important;
}
/* @media (orientation: landscape) {
    .refresh-label {
        height: 10vh; 
    }
} */
.refresh-component{
  height:100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

}
.button-div.v-btn--disabled {
  opacity: 1 !important;
  pointer-events: none; 
  
}

.button-div.v-btn--disabled .v-btn__content {
  color: inherit !important;
}
.progress-circle {
  position: absolute;
  margin: auto;
  
  max-height: 40px;
}
.refresh-button{
  display: flex;
  grid-area: content;
  justify-content: center;
  flex-direction: row;
  
  border-radius: 50% !important; 
  /* margin: 2px; */
  margin-top:-8px; 
  margin-right: -22px;
  z-index: 9999;
  /* padding:2px; */
}
.refresh-icon {
  position: absolute;
  margin: auto;
  max-height: 20px;
}

.refresh-icon-spinning {
  animation: refresh-icon-spin 1s linear infinite;
}

@keyframes refresh-icon-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(-360deg);
  }
}

/* .v-theme--dark .refresh-icon {
  filter: brightness(0) invert(1);
} */
.disabled-image {
  opacity: 0.2;
}
</style>
